import axios from 'axios';
import { formatToDateTimeSec } from '@/utils/formatters.js';
import * as adminService from '@/services/adminApiService.js';

export const reportManagerMixin = {
  data() {
    return {
      reportsData: [],
      isReportsLoading: false,
      isUploadModalVisible: false,
      reportToReplace: null,
    };
  },
  methods: {
    async loadReports() {
      this.isReportsLoading = true;
      try {
        const response = await axios.get('/api/reports');
        this.reportsData = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        alert('获取报告列表失败: ' + (error.response?.data?.error || error.message || '未知错误'));
        this.reportsData = [];
      } finally {
        this.isReportsLoading = false;
      }
    },

    async handleDeleteInReports(id) {
      try {
        await adminService.deleteReport(id);
        this.reportsData = this.reportsData.filter(r => r.id !== id);
      } catch (err) {
        alert('删除失败: ' + err.message);
      }
    },

    openUploadModalInReports(fileToReplace = null) {
      this.reportToReplace = fileToReplace;
      this.isUploadModalVisible = true;
    },

    handleReportUploadSuccess() {
      this.loadReports();
      this.reportToReplace = null;
    },
    
    async handleMoveReport({ index, direction }) {
      if ((direction === 'up' && index === 0) || 
          (direction === 'down' && index === this.reportsData.length - 1)) {
        return;
      }
      const newReports = [...this.reportsData];
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      [newReports[index], newReports[newIndex]] = [newReports[newIndex], newReports[index]];
      this.reportsData = newReports;

      try {
        await adminService.saveReportOrder(this.reportsData.map(r => r.id));
      } catch (err) {
        alert('排序保存失败: ' + err.message);
        this.loadReports();
      }
    },

    formatFileSize(bytes) {
      if (bytes == null || isNaN(bytes)) return 'N/A';
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatToDateTimeSec,
  },
};